module.exports = __webpack_public_path__ + "static/media/mais.82443fe1.png";